import React from 'react';
import ReservarCirugia from '../reservacion/pages/reservar_cirugia';

/**
 * Modal que embebe el wizard de "Nueva reserva" (proyecto reservacion),
 * preseleccionando unidad hospitalaria, sala y hora de inicio según el
 * espacio disponible en el que se dio clic dentro de la grilla de Agenda.
 *
 * El wizard llama directamente a los servicios (Cloud Functions) del
 * proyecto de reservación — no usa Firestore — así que al completarse,
 * el nuevo evento aparecerá automáticamente en "Pendientes" gracias al
 * listener en tiempo real de useEventos, sin necesidad de recargar nada.
 */
const NuevaReservaModal = ({ preset, onClose }) => {
  if (!preset) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed', inset: 0, background: 'rgba(17,24,39,.65)',
        display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
        zIndex: 1200, padding: '24px 16px', overflowY: 'auto',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '760px',
          boxShadow: '0 20px 60px rgba(0,0,0,.35)', overflow: 'hidden',
        }}
      >
        <ReservarCirugia
          presetUnidad={preset.unidad}
          presetSala={preset.sala}
          presetFecha={preset.fecha}
          presetHoraInicial={preset.horaInicial}
          presetNoProgramada={preset.noProgramada}
          onClose={onClose}
        />
      </div>
    </div>
  );
};

export default NuevaReservaModal;
